<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="light-container-popup-basic">
	<div class="light-container__header">{{ appStrings.PASTE_MOVE_ACTIVE_LINE_POPUP_HEADER }}</div>
	<div class="light-container__text-block text-and-calendar-layout move-active-line-popup-plain-text">
		{{ appStrings.PASTE_MOVE_ACTIVE_LINE_POPUP_DESCRIPTION_LINE }}<br />
		<br />
		{{ appStrings.PASTE_MOVE_ACTIVE_LINE_POPUP_MOVE_PREFIX }} <b>{{ formatMaxTicketDateInClipboard() }}</b
		>, {{ appStrings.PASTE_MOVE_ACTIVE_LINE_POPUP_MOVE_SUFFIX }}<br />
		<br />
		<!--
			TODO
			Have the calendar disable non-working days.
			Tried copying some code from "ticket-calendar.component.ts" to do that,
			but it didn't work, so more work/time is needed.

				[disabledDates]="getCalendarNonWorkingDays()"
		-->
		<mat-form-field class="single-day">
			<mat-label>{{ appStrings.CONSTRAINT_DUE_DATE }}</mat-label>
			<input matInput [matDatepicker]="needbypicker" [formControl]="calendarFormControl" />
			<mat-datepicker-toggle
				automationId="needbypicker"
				matSuffix
				[for]="needbypicker"
			></mat-datepicker-toggle>
			<mat-datepicker touchUi #needbypicker></mat-datepicker>
		</mat-form-field>
	</div>
	<div class="light-container-popup__footer space-children-h">
		<button
			(click)="writeCancel(); complete()"
			class="legacy-button btn--white"
			automationId="pasteActiveLineCancel"
		>
			{{ appStrings.PASTE_MOVE_ACTIVE_LINE_POPUP_CANCEL_LABEL }}
		</button>
		<button
			(click)="writeOutput(); complete()"
			class="legacy-button btn--blue"
			automationId="pasteActiveLineOK"
		>
			{{ appStrings.PASTE_MOVE_ACTIVE_LINE_POPUP_OK_LABEL }}
		</button>
	</div>
</div>
